import client from "braintree-web/client";
import {BraintreeError} from "braintree-web/core";
import paypal, {PayPalTokenizePayload} from "braintree-web/paypal";
import {useEffect} from "react";

export interface PaymentMethodPaypalFormProps {
  onReady: (
    tokenizeFn: (options: object, callback: (err: BraintreeError, payload?: PayPalTokenizePayload) => void) => void
  ) => void;
  onError: (errors: string[]) => void;
  braintreeToken: string;
}

export const PaymentMethodPaypalForm = ({onReady, braintreeToken, onError}: PaymentMethodPaypalFormProps) => {
  useEffect(() => {
    client.create({authorization: braintreeToken}, (createErr, clientInstance) => {
      if (createErr) {
        onError(["Our payment provider reported an error.", createErr.message]);
        console.error("Error initializing BT", createErr);
        return;
      }
      paypal.create(
        {
          client: clientInstance,
        },
        (paypalErr, paypalInstance) => {
          if (paypalErr || !paypalInstance) {
            onError(["Our payment provider reported an error.", paypalErr?.message || ""]);
            console.error("Error initializing Paypal", paypalErr);
            return;
          }
          onReady(() => paypalInstance.tokenize.bind(paypalInstance));
        }
      );
    });
  }, [braintreeToken]);
  return <div id="paypal-container"></div>;
};
